/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class WaitlistService {
    /**
     * Add entry to waitlist
     * Creates a new waitlist entry. Email must be unique.
     * @param requestBody
     * @returns any Successfully added to waitlist
     * @throws ApiError
     */
    public static postApiV2Waitlist(
        requestBody: {
            email: string;
            firstName: string;
            lastName: string;
            userType: 'BUYER' | 'SUPPLIER';
            additionalInfo?: string | null;
            companyName?: string | null;
        },
    ): CancelablePromise<{
        status?: boolean;
        message?: string;
        data?: {
            /**
             * The auto-generated ID of the waitlist entry
             */
            id?: number;
            /**
             * Email address (must be unique)
             */
            email: string;
            /**
             * First name
             */
            firstName: string;
            /**
             * Last name
             */
            lastName: string;
            /**
             * User type - Buyer or Supplier
             */
            userType: 'BUYER' | 'SUPPLIER';
            /**
             * Additional information provided by the user
             */
            additionalInfo?: string | null;
            /**
             * Company name (optional)
             */
            companyName?: string | null;
            /**
             * Timestamp when the entry was created
             */
            created?: string;
            /**
             * Timestamp when the entry was last updated
             */
            updated?: string;
        };
    }> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/v2/waitlist',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Validation error - missing required fields or invalid user type`,
                409: `Email already exists in waitlist`,
                500: `Internal server error`,
            },
        });
    }
    /**
     * Get all waitlist entries
     * Retrieves all waitlist entries, optionally filtered by user type
     * @param userType Filter by user type
     * @returns any Waitlist entries retrieved successfully
     * @throws ApiError
     */
    public static getApiV2Waitlist(
        userType?: 'BUYER' | 'SUPPLIER',
    ): CancelablePromise<{
        status?: boolean;
        message?: string;
        data?: Array<{
            /**
             * The auto-generated ID of the waitlist entry
             */
            id?: number;
            /**
             * Email address (must be unique)
             */
            email: string;
            /**
             * First name
             */
            firstName: string;
            /**
             * Last name
             */
            lastName: string;
            /**
             * User type - Buyer or Supplier
             */
            userType: 'BUYER' | 'SUPPLIER';
            /**
             * Additional information provided by the user
             */
            additionalInfo?: string | null;
            /**
             * Company name (optional)
             */
            companyName?: string | null;
            /**
             * Timestamp when the entry was created
             */
            created?: string;
            /**
             * Timestamp when the entry was last updated
             */
            updated?: string;
        }>;
    }> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v2/waitlist',
            query: {
                'userType': userType,
            },
        });
    }
}
